import Marquee from "react-fast-marquee";
import { Plus } from "lucide-react";
import { HIGHLIGHTS } from "@/data/site";

export const ServiceMarquee = () => {
  return (
    <section className="relative border-y border-slate-200 bg-brand-blue py-6 lg:py-7">
      <Marquee speed={45} gradient={false} autoFill pauseOnHover>
        {HIGHLIGHTS.map((h, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-heading text-lg sm:text-xl font-semibold tracking-tight text-white/95">
              {h}
            </span>
            <Plus className="h-4 w-4 text-brand-green-light" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
